import { defineComponent as _defineComponent } from 'vue'
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';
import {
	useConstantStore,
	useFooterStore,
	useLanguageStore,
	useRoutingStore,
	useUserStore,
} from '@/helpers/composables/useStores';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const AppDefaultFooter = () =>
	import(/* webpackChunkName: "default-footer" */ '@/components/footer/AppDefaultFooter.vue');
const AppFooterEuropeanBanner = () =>
	import(/* webpackChunkName: "european-banner-footer" */ '@/components/footer/AppFooterEuropeanBanner.vue');

const route = useRoute();
const { webLocale, locale, country } = useLanguageStore();
const { providers } = useConstantStore();
const { urlMetadataPromise } = useRoutingStore();
const { isUserOnboarded } = useUserStore();
const { topTitles, topArticles } = useFooterStore();

const showAnyFooter = computed(() => !COUNTRY_WITHOUT_TITLEDETAIL.includes(webLocale.value));

const showDefaultFooter = computed(() => route.name !== 'app.home');

const metaReady = ref(false);
const coldStart = ref(true);

onMounted(() => {
	coldStart.value = false;
});

start();

// setup
async function start() {
	await urlMetadataPromise.value;
	metaReady.value = true;
}

return { __sfc: true,AppDefaultFooter, AppFooterEuropeanBanner, route, webLocale, locale, country, providers, urlMetadataPromise, isUserOnboarded, topTitles, topArticles, showAnyFooter, showDefaultFooter, metaReady, coldStart, start }
}

})